import { render, staticRenderFns } from "./TipoDeUnidadeOperacional.vue?vue&type=template&id=bc889ce6&"
import script from "./TipoDeUnidadeOperacional.vue?vue&type=script&lang=js&"
export * from "./TipoDeUnidadeOperacional.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports